<script setup lang="ts">
import { onMounted } from 'vue'
import LoadingSpinner from '../../../base/LoadingSpinner.vue'

import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import AccountKycProcessLegal from '../verification/AccountKycProcessLegal.vue'
import AccountPanelLegalMissingDataAlert from '../AccountPanelLegalMissingDataAlert.vue'

const state = useLegalAccountDataState()

onMounted(() => {
    state.fetchKycDocuments()
})
</script>

<template>
    <AccountPanelLegalMissingDataAlert
        v-if="!state.hasAllRequiredProfileAttributesForInvestment"
        inline
        :description-text="$t('verification.complete_data_description_for_verification')"
        class="my-9" />
    <AccountKycProcessLegal v-else-if="!state.kycDocumentsLoading" class="px-6" profile-type="legal" />
    <div v-else class="flex h-[10vh] items-center justify-center">
        <LoadingSpinner class="h-10 w-10 fill-primary" />
    </div>
</template>
